import { useContext, useEffect } from 'react'
import AppContext from 'context/app'

/**
 * Image Options allows users to specify
 * position, objectFit, and size
 * at different breakpoints
 */
const useImgOptions = ({ imgOptions, setImageSize, setObjectFit, setImagePlacement }) => {
    const { clientWidth } = useContext(AppContext)

    const sortOptions = () => {
        // order of options in builder doesn't matter
        return imgOptions.sort((a, b) => {
            if (!a.hasOwnProperty('breakpoint')) return -1
            else if (!b.hasOwnProperty('breakpoint')) return 1
            else return b.breakpoint - a.breakpoint
        })
    }

    const findOption = () => {
        const optionsSorted = sortOptions()
        // console.log(clientWidth, optionsSorted)
        
        /**
         * if there is no option where the breakpoint is greater than the client width
         * then choose the option with no breakpoint
         */
        const option = 
            optionsSorted.findLast(({ breakpoint }) => breakpoint >= clientWidth) ??
            imgOptions.find(({ breakpoint }) => !breakpoint)
        
        return option
    }

    useEffect(() => {
        if (!imgOptions || !imgOptions.length) return
        const option = findOption()
        setImagePlacement(option?.imgPlacement)
        setObjectFit(option?.objectFit)
        setImageSize(option?.imgSize)
    }, [clientWidth, imgOptions])
}

export default useImgOptions